var _rect, _defs, _defs2, _defs3, _defs4, _defs5, _defs6, _defs7, _defs8, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlobRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visual",
    viewBox: "0 0 900 600",
    width: 900,
    height: 600,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 900,
    height: 600,
    fill: "#ffffff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad1_0",
    x1: "33.3%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "20%",
    stopColor: "#ff6d4f",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "80%",
    stopColor: "#ff6d4f",
    stopOpacity: 1
  })))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad1_1",
    x1: "33.3%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "20%",
    stopColor: "#ff6d4f",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "80%",
    stopColor: "#ffa087",
    stopOpacity: 1
  })))), _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad1_2",
    x1: "33.3%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "20%",
    stopColor: "#ffd0c2",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "80%",
    stopColor: "#ffa087",
    stopOpacity: 1
  })))), _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad1_3",
    x1: "33.3%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "20%",
    stopColor: "#ffd0c2",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "80%",
    stopColor: "#ffffff",
    stopOpacity: 1
  })))), _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad2_0",
    x1: "0%",
    y1: "0%",
    x2: "66.7%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "20%",
    stopColor: "#ff6d4f",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "80%",
    stopColor: "#ff6d4f",
    stopOpacity: 1
  })))), _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad2_1",
    x1: "0%",
    y1: "0%",
    x2: "66.7%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "20%",
    stopColor: "#ffa087",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "80%",
    stopColor: "#ff6d4f",
    stopOpacity: 1
  })))), _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad2_2",
    x1: "0%",
    y1: "0%",
    x2: "66.7%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "20%",
    stopColor: "#ffa087",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "80%",
    stopColor: "#ffd0c2",
    stopOpacity: 1
  })))), _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad2_3",
    x1: "0%",
    y1: "0%",
    x2: "66.7%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "20%",
    stopColor: "#ffffff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "80%",
    stopColor: "#ffd0c2",
    stopOpacity: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(900, 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 486.7C-63.3 479.9 -126.6 473.1 -186.3 449.7C-246 426.3 -302 386.3 -335.9 335.9C-369.7 285.4 -381.4 224.6 -402.8 166.8C-424.3 109.1 -455.5 54.6 -486.7 0L0 0Z",
    fill: "#ffe7e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 365.1C-47.5 359.9 -94.9 354.8 -139.7 337.3C-184.5 319.7 -226.5 289.7 -251.9 251.9C-277.3 214.1 -286 168.4 -302.1 125.1C-318.2 81.8 -341.6 40.9 -365.1 0L0 0Z",
    fill: "#ffb8a4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 243.4C-31.6 240 -63.3 236.6 -93.1 224.8C-123 213.1 -151 193.2 -167.9 167.9C-184.9 142.7 -190.7 112.3 -201.4 83.4C-212.1 54.6 -227.8 27.3 -243.4 0L0 0Z",
    fill: "#ff876b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 121.7C-15.8 120 -31.6 118.3 -46.6 112.4C-61.5 106.6 -75.5 96.6 -84 84C-92.4 71.4 -95.3 56.1 -100.7 41.7C-106.1 27.3 -113.9 13.6 -121.7 0L0 0Z",
    fill: "#ff6d4f"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 600)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -486.7C47.5 -442 95 -397.3 157.7 -380.6C220.3 -363.9 298.1 -375.2 344.2 -344.2C390.3 -313.1 404.7 -239.7 423.1 -175.3C441.6 -110.8 464.2 -55.4 486.7 0L0 0Z",
    fill: "#ffe7e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -365.1C35.6 -331.5 71.3 -298 118.2 -285.5C165.2 -273 223.6 -281.4 258.1 -258.1C292.7 -234.8 303.5 -179.8 317.4 -131.5C331.2 -83.1 348.1 -41.6 365.1 0L0 0Z",
    fill: "#ffb8a4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -243.4C23.8 -221 47.5 -198.7 78.8 -190.3C110.2 -182 149 -187.6 172.1 -172.1C195.1 -156.6 202.3 -119.8 211.6 -87.6C220.8 -55.4 232.1 -27.7 243.4 0L0 0Z",
    fill: "#ff876b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -121.7C11.9 -110.5 23.8 -99.3 39.4 -95.2C55.1 -91 74.5 -93.8 86 -86C97.6 -78.3 101.2 -59.9 105.8 -43.8C110.4 -27.7 116 -13.9 121.7 0L0 0Z",
    fill: "#ff6d4f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlobRed);
export default __webpack_public_path__ + "static/media/blob_red.3f09198efea22575c47047e347bd59ac.svg";
export { ForwardRef as ReactComponent };